export class SgfDetMovDia {
    id: {
        codOficina: number;
        codTransaccion: string;
        numTransaccion: number;
        numSec: number;
    };
    fecMovimiento: Date;
    valCheques:number; 
    valEfectivo:number;
    stsMov: string;
    codCuenta: number;
    codProducto: number
}

